import React from 'react'
import Link from 'gatsby-link'
import get from 'lodash/get'
import Helmet from 'react-helmet'
import styled from 'styled-components'

const Article = styled.article`
  display: block;
  margin-bottom:10px;
  border: 1px solid transparent;
  &.active {
    border: 1px dashed #000;    
  }
  & > h2 {
    display: inline;
    margin-bottom: 20px;
    a {
      font-size: 30px;
      color: black;
    }
  }
`

const P = styled.p`
  position:relative;
  left:10px;
  top:20px;
  font-family: 'Inconsolata', Courier;
  font-size: 18px;
  line-height: 1.3;
  white-space: pre-wrap;  
  word-wrap: break-word;  
  margin-bottom:10px;
`

const Comment = styled.article`
  position:relative;
  display:block;
  min-height:50px;
  margin-left: 0;
  border: 1px solid transparent;  
`

const Info = styled.span`
  position:relative;
  left:0px;
  font-size:14px;
  color:#666;
`

const Readmore = styled.div`
  margin-top:20px;
  margin-left:10px;
  a {
    color: black;
  }
`

const Detail = styled.div`
  display: block;
  margin-bottom: 30px;
`

class BlogIndex extends React.Component {
  render() {
    const meta = get(this, 'props.data.site.siteMetadata')
    const posts = get(this, 'props.data.allMarkdownRemark.edges')

    return (
      <section>
        <Helmet title={'List of posts - ' + meta.title} />
        {posts.map(({ node }) => {
          const title = get(node, 'frontmatter.title') || node.fields.slug
          return (
            <Article key={node.fields.slug}>
              <h2>
                <Link to={node.fields.slug}>
                  {title}
                </Link>
              </h2>
              <Detail>
                <Comment >
                  <Info >
                    {node.frontmatter.date}
                  </Info>
                  <P dangerouslySetInnerHTML={{ __html: node.excerpt }}>
                  </P>
                </Comment>
                <Readmore>
                  <i>
                    <a href={node.fields.slug}>read the full post at {meta.siteUrl + node.fields.slug} </a>
                  </i>
                </Readmore>
              </Detail>
            </Article>
          )
        })}
      </section>
    )
  }
}

export default BlogIndex
    
export const pageQuery = graphql`
  query IndexQuery {
    site {
      siteMetadata {
        title
        siteUrl
      }
    }
    allMarkdownRemark(sort: {fields: [frontmatter___date], order: DESC}) {
      edges {
        node {
          excerpt
          fields {
            slug
          }
          frontmatter {
            date(formatString: "DD MMMM, YYYY")
            title
          }
        }
      }
    }
  }        
`



// WEBPACK FOOTER //
// ./src/pages/index.js